var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"faq",staticClass:"faq"},[_c('CKEditor',{attrs:{"content":_vm.get_content(),"scope":"FAQ"},on:{"submit":_vm.set_content}}),_c('br'),_c('div',{staticStyle:{"background-color":"#f4f4f1","padding":"10px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }